import { meta } from '@/helpers/constants/router';
const Wrapper = () => import('@/views/Wrapper.vue');
const Overview = () => import('@/views/v2/network_distributor/Overview.vue');
const Merchants = () => import('@/views/v2/network_distributor/Merchants.vue');
const MerchantsByStatus = () => import('@/components/v2/network_distributor/MerchantsByStatus.vue');
const Merchant = () => import('@/views/v2/network_distributor/Merchant.vue');
const MerchantOrder = () => import('@/components/v2/network_distributor/MerchantOrderHistory.vue');
const MerchantSettings = () => import('@/components/v2/network_distributor/MerchantSettings.vue');
const MerchantBilling = () => import('@/components/v2/network_distributor/MerchantBillingHistory.vue');
// const MiniApps = () => import('@/views/v2/network_distributor/MiniApps.vue');
export default [
    {
        path: 'overview',
        component: Wrapper,
        redirect: 'reseller-mini-apps-overview',
        meta: { ...meta, title: 'Overview' },
        children: [
            {
                path: '/',
                component: Overview,
                name: 'reseller-mini-apps-overview',
                meta: {
                    title: 'Overview',
                },
            },
        ],
    },
    {
        path: 'merchants',
        component: Wrapper,
        meta: { ...meta, redirect: 'reseller-merchants-by-status', title: 'Merchants' },
        children: [
            {
                path: ':status',
                name: 'reseller-merchants-dashboard',
                redirect: 'reseller-merchants-by-status',
                meta: { title: 'Merchants' },
                props: true,
                component: Merchants,
                children: [
                    {
                        path: '/',
                        name: 'reseller-merchants-by-status',
                        meta: { title: 'Merchants' },
                        props: true,
                        component: MerchantsByStatus,
                    },
                ],
            },
            {
                path: ':merchantUuid',
                meta: { redirect: 'reseller-merchants-by-status', title: 'Merchants' },
                props: true,
                component: Merchant,
                children: [
                    {
                        path: 'details',
                        name: 'reseller-specific-merchant-details',
                        meta: { title: 'Details' },
                        props: true,
                        component: MerchantOrder,
                    },
                    {
                        path: 'settings',
                        name: 'reseller-specific-merchant-settings',
                        meta: { title: 'Settings' },
                        props: true,
                        component: MerchantSettings,
                    },
                    {
                        path: 'billings',
                        name: 'reseller-specific-merchant-billings',
                        meta: { title: 'Billings' },
                        props: true,
                        component: MerchantBilling,
                    },
                ],
            },
        ],
    },
];
